import * as Yup from "yup";

export const ExitProtocolValidationSchema = Yup.object({
  emotion: Yup.string().required("Required"),
  newStrategy: Yup.string().required("Required"),
  exitReason: Yup.string().required("Required"),
});
